import { type AssignableShigoRole, ShigoRole } from '../../auth/permissions';

export const networkConfigurableRoles = [
  ShigoRole.Admin,
  ShigoRole.AdminReadOnly,
  ShigoRole.User,
  ShigoRole.UserReadOnly,
  ShigoRole.Publisher,
  ShigoRole.Agency,
] as const satisfies readonly AssignableShigoRole[];
